import { motion } from "framer-motion";

const ITEMS = [
  {
    tag: "24×7",
    title: "Security Monitoring & Response",
    body:
      "Continuous monitoring across endpoints, networks, cloud environments, applications, and identities with clearly defined detection and response SLAs.",
  },
  {
    tag: "MITRE",
    title: "Threat Detection Engineering",
    body:
      "Security monitoring tailored to your environment through custom detection use cases, continuous rule tuning, and MITRE ATT&CK-aligned coverage.",
  },
  {
    tag: "INTEL",
    title: "Threat Intelligence & Risk Insights",
    body:
      "Actionable intelligence enriched with industry, regional, and threat actor context to help identify emerging risks and prioritize response.",
  },
  {
    tag: "DFIR",
    title: "Incident Response & Digital Forensics",
    body:
      "Rapid investigation, containment, and remediation of security incidents supported by documented playbooks, forensic analysis, and recovery guidance.",
  },
  {
    tag: "EXP",
    title: "Vulnerability & Exposure Management",
    body:
      "Continuous identification, prioritization, and tracking of vulnerabilities based on real-world exploitability — not just severity scores.",
  },
  {
    tag: "HUNT",
    title: "Proactive Threat Hunting",
    body:
      "Hypothesis-driven hunts designed to uncover hidden threats, attacker activity, and indicators of compromise before they escalate.",
  },
  {
    tag: "PURPLE",
    title: "Security Validation & Adversary Simulation",
    body:
      "Regular red team, purple team, and breach simulation exercises to validate the effectiveness of security controls and detection capabilities.",
  },
];

export default function SOCList() {
  return (
    <section
      data-testid="soc-list"
      className="theme-editorial relative border-t border-[rgba(17,17,17,0.06)] bg-[#FAFAFA] py-16 md:py-24"
      aria-label="24×7 SOC capabilities"
    >
      <div className="mx-auto max-w-[1280px] px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-6 md:gap-10 mb-12 md:mb-16">
          <div className="md:col-span-5">
            <div className="font-mono text-[10px] tracking-[0.32em] text-[#8A8A8A] mb-4">
              [ 24×7 SOC · OPERATIONS ]
            </div>
            <h2 className="font-editorial-display text-[40px] md:text-[60px] leading-[0.98] tracking-[-0.028em] text-[#111]">
              Cyber threats don't
              <br />
              operate on a schedule.
              <br />
              <span className="font-editorial-italic text-[#5B2A86]">
                Neither should
              </span>{" "}
              your defense.
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-[16px] md:text-[18px] leading-[1.55] text-[#2A2A2A]">
              RockLadder's SOC operates 24×7 to provide continuous monitoring, threat detection,
              investigation, and incident response — with well-defined SLAs and MITRE ATT&CK-aligned
              coverage.
            </p>
          </div>
        </div>

        <ul className="divide-y divide-[rgba(17,17,17,0.10)] border-t border-b border-[rgba(17,17,17,0.10)]">
          {ITEMS.map((it, i) => (
            <motion.li
              key={it.title}
              data-testid={`soc-item-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: i * 0.04 }}
              className="group py-6 md:py-8 grid grid-cols-12 gap-4 md:gap-8 items-start hover:bg-white/60 transition-colors"
            >
              <div className="col-span-2 md:col-span-1 font-mono text-[10px] tracking-[0.32em] text-[#5B2A86] pt-1">
                0{i + 1}
              </div>
              <div className="col-span-10 md:col-span-3">
                <span className="inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.28em] text-[#111]">
                  <span className="h-1.5 w-1.5 rounded-full bg-[#F5B841]" />
                  {it.tag}
                </span>
                <h3 className="mt-3 font-editorial-display text-[24px] md:text-[30px] leading-[1.05] tracking-[-0.02em] text-[#111]">
                  {it.title}
                </h3>
              </div>
              <p className="col-span-12 md:col-span-7 md:col-start-6 text-[15px] md:text-[16px] leading-[1.55] text-[#2A2A2A]">
                {it.body}
              </p>
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
}
